import { Field, InputType, ObjectType } from 'type-graphql'
import GraphQLJSON from 'graphql-type-json'
import { modelOptions, Prop, Severity } from '@typegoose/typegoose'
import mongoose from 'mongoose'
import { generateEntityId } from '../generateEntityId'
import { RelatedEntity } from '../base/RelatedEntity'
import type { Tenant } from '../tenant/Tenant'

@ObjectType('History')
@modelOptions({ options: { allowMixed: Severity.ALLOW } })
@InputType('HistoryInput')
export class History {
  @Field(() => String)
  @Prop({ type: String, required: true, default: () => generateEntityId('his') })
  declare _id: string

  @Field(() => String)
  @Prop({ type: String })
  entityKey: string

  @Field(() => String)
  @Prop({ type: String })
  entity: string

  @Field(() => Date)
  @Prop({ type: Date })
  timeStamp: Date

  @Field(() => String)
  @Prop({ type: String })
  description?: string

  @Field(() => String)
  @Prop({ type: String })
  author: string

  @Field(() => String)
  @Prop({ type: String })
  diff?: string

  @Field(() => GraphQLJSON)
  @Prop({ type: mongoose.Schema.Types.Mixed })
  meta?: object

  //never exposed on the schema: the owning tenant stamped at creation, so reads can be
  //scoped to the caller's tenant. Rows predating the stamp carry no tenant and stay visible.
  @Prop({ type: RelatedEntity })
  tenant?: Tenant
}
